export default "__VITE_ASSET__C6vZHC56__"